"use strict";

var locations = "";
var locationsInfos = "";
var map;
var markers = [];
var debug = false;
var possibleErrors, specificExceptions, sherbrookeCoords, sorelCoords, quebecCoords, lavalCoords, montrealCoords;

/*
function testRandom() {
  index = Math.floor(Math.random() * testNames.length);
  $("[name=address]").val(testNames[index]);
  getGeocode();
}
*/

function is_in_geometry(latLng, mapGeometry, index) {
  return google.maps.geometry.poly.containsLocation(latLng, mapGeometry) ? index : -1;
}

function showSpecificPoint(latLng, zoom) {
  map.setCenter(latLng);
  map.setZoom(zoom);
}

function checkIfZoneException(geometryLocation) {
  var i = 0;
  var index = -1;

  while (i < specificExceptions.length && index == -1) {
    index = is_in_geometry(geometryLocation, specificExceptions[i][6], i);
    i++;
  }

  return index;
}

function checkForErrors(name) {
  var trimmedName = name.trim().toLowerCase();
  var found = false;

  for (var i = 0; i != possibleErrors.length; i++) {
    for (var j = 0; j != possibleErrors[i][1].length; j++) {
      if (trimmedName == possibleErrors[i][1][j]) {
        name = possibleErrors[i][0];
        found = true;
        break;
      }
    }

    if (found) {
      break;
    }
  }

  var containsLetter = name.match(/[a-zA-Z]+/) != null;

  if (!found && containsLetter) {
    name += " canada";
  }

  return name;
}

function viewAllMarkers() {
  //alert('allmarkers')
  if(markers.length > 1 ){
		var bounds = new google.maps.LatLngBounds();
		for (var i = 0; i < markers.length; i++) {
			bounds.extend(markers[i].getPosition());
		}

		map.fitBounds(bounds);
	} else {
		map.setZoom(14);
	}
}

function filterAddress(address) {
  var adr = address.trim().toLowerCase();
  /*
  switch(adr){
  	case "laval, quebec": adr = "45.6066486 -73.7124091" ; break;
  	case "montreal":
  	case "montrÃ©al":
  		adr = "45.536465 -73.6146708" ; break;
  }
  */

  return adr;
}

function rad(x) {
  return x * Math.PI / 180;
}

var distances = [];
var nextGeocode = "";
var geocodeLocked = false;


function getGeocode() {
  //var address = $("[name=address]").val();
  var address = document.getElementsByName('address')[0].value;
  //alert(address);
  getMapPoint(address);
}


function getCurrentPosition() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(geoToMap, showGeoError);
  } else {
    alert("Ce navigateur ne supporte pas la geolocalisation");
  }
}

function geoToMap(position) {
  getMapPoint(position.coords.latitude + " , " + position.coords.longitude);
}


function showGeoError(error) {
  var lang = document.getElementById('lang').value
  var texte = "";

  switch (lang) {
    case "fr":
      texte = "Impossible de trouver votre position actuelle. Assurez-vous d'activer votre geolocalisation.";
      break;

    default:
      texte = "Can't find your current location. Make sure geolocation is enabled.";
  }

  alert(texte);
}

function saveSearch(position) {
  $.ajax({
    method: "POST",
    url: "/search-save-endpoint/",
    data: {
      address: position
    }
  });
}

function getMapPoint(address) {

  if (!geocodeLocked) {
    address = checkForErrors(address);
    if (address != "") {
      var geocoder = new google.maps.Geocoder();
      distances = [];
      address = filterAddress(address);
      //alert(address);
      geocoder.geocode({
        "address": address
      }, function (result, status) {
        //alert(status);
        if (status === "OK") {
          //if (!isAmp) {
            //alert('gotoid');
            console.log(result);
            //GoToId("map");
          //}

          var exceptionIndex = checkIfZoneException(result[0].geometry.location);

          if (exceptionIndex != -1) {
            var exception = specificExceptions[exceptionIndex];
            var position = {
              "lat": function lat() {
                return exception[1].lat;
              },
              "lng": function lng() {
                return exception[1].lng;
              }
            }; // if force position

            if (exception[5]) {
              //alert('find_closest_marker_zone1');
              find_closest_marker_zone(position, exception);
            } else {
              //alert('find_closest_marker_zone2');
              find_closest_marker_zone(result[0].geometry.location, exception);
            }
          } else {
            //alert('find_closest_marker');
            find_closest_marker(result[0].geometry.location, markers, true);
          }
        }

        if (status === 'ZERO_RESULTS') {
          showError("La recherche n'a donnÃ© aucun rÃ©sultat");
        }
      });
    } else {
      showError("La recherche n'a donnÃ© aucun rÃ©sultat");
    }
  }

} // Modification of https://stackoverflow.com/questions/4057665/google-maps-api-v3-find-nearest-markers


function find_closest_marker(position, markersList, confirm) {
  //console.log(markersList);
  distances = [];
  var lat = position.lat();
  var lng = position.lng();
  var R = 6371; // radius of earth in km

  var closest = -1;

  for (var i = 0; i < markersList.length; i++) {
    var mlat = markersList[i].position.lat();
    var mlng = markersList[i].position.lng();
    var dLat = rad(mlat - lat);
    var dLong = rad(mlng - lng);
    //console.log('('+mlat+')()'+mlng+')');
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(lat)) * Math.cos(rad(lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    var indexMarker = -1;
    //console.log(markers);
    for (var j = 0; j < markers.length; j++) {
      if (markers[j] == markersList[i]) {
        indexMarker = j;
      }
    }

    if(!isNaN(d)){
      distances.push([indexMarker, d]);
    }
  }

  distances.sort(function (a, b) {
    return a[1] - b[1];
  });
	/*limiter le nombre de resultat*/
  distances = distances.slice(0, 15);
  if (confirm) {
    confirm_closest_marker(position, null);
  }
  //console.log(distances);
  return distances;
}

function find_closest_marker_zone(position, exception) {
  var inZone = [];
  var notInZone = [];

  for (var i = 0; i < markers.length; i++) {
    if (is_in_geometry(markers[i].position, exception[6], 1) == -1) {
      notInZone.push(markers[i]);
    } else {
      inZone.push(markers[i]);
    }
  }

  var distanceZone = find_closest_marker(position, inZone, false);
  var distanceNotZone = find_closest_marker(position, notInZone, false);
	/*changer le nombre de resultat*/
  distances = distanceZone.concat(distanceNotZone).slice(0, 5);
  confirm_closest_marker(position, exception);
}

var ajaxdata = "";
/*
function confirm_closest_marker( position ){
	var destinations = "";

	for(var i = 0; i < distances.length; i++){
		var marker = markers[distances[i][0]];
		destinations += marker.position.lat()+","+marker.position.lng()+"|";
	}
	destinations = destinations.substr(0,destinations.length-1);

	var queryUrl = "https://maps.googleapis.com/maps/api/distancematrix/json?";
	queryUrl += "language="+lang;
	queryUrl += "&avoid=ferries";
	queryUrl += "&origins="+position.lat()+","+position.lng();
	queryUrl += "&destinations="+destinations;
	queryUrl += "&key=AIzaSyDdPxM57dl5izAJP7vAgUaOV47D1uhXDBg";
	queryUrl = encodeURI(queryUrl);

	$.ajax({
		url: queryUrl,
		type: "GET",
		dataType: 'jsonp',
		cache: false,
		success: function(data){
			console.log(data);
			ajaxdata = data;
			for(var i = 0; i < data.rows[0].length ; i++){
				distances[i][1] - data.rows[0][i].distance.text;
			}
		}
	});

	//console.log(encodeURI(queryUrl));
}
*/

function confirm_closest_marker(position, exception) {
  var destinations = [];

  for (var i = 0; i < distances.length; i++) {
    var marker = markers[distances[i][0]];
    destinations.push(marker.position.lat() + "," + marker.position.lng());
  }

  var distanceService = new google.maps.DistanceMatrixService();
  distanceService.getDistanceMatrix({
    origins: [position.lat() + "," + position.lng()],
    destinations: destinations,
    travelMode: google.maps.TravelMode.DRIVING,
    unitSystem: google.maps.UnitSystem.METRIC,
    avoidHighways: false,
    avoidTolls: false,
    avoidFerries: true
  }, function (response, status) {
    if (status == google.maps.DistanceMatrixStatus.OK) {
      var elems = response.rows[0].elements;

      for (var i = 0; i < elems.length; i++) {
        distances[i][1] = elems[i].distance.value;
      }

      distances.sort(function (a, b) {
        return a[1] - b[1];
      });

      if (exception != null) {
        showSpecificPoint(exception[1], exception[2]);
        showAllDistances();
        //alert('exception');
      } else {
        setMapToMarker(distances[0][0]);
        showAllDistances();
        //alert('noexception');
      }
    }
  });
}

function showError(errormsg) {
  viewAllMarkers();
  $(".errormsg").text(errormsg);
  $(".errormsg").css({
    "display": "block"
  });
}

function setMapToMarker(markerIndex) {
  map.setCenter(markers[markerIndex].position);
  map.setZoom(14); //google.maps.event.trigger(markers[markerIndex], 'click')
}

function changePage(pageNo) {
  $(".pages").hide();
  $("#page-" + pageNo).show();
  resizePage();
}

function setDefaultMap(){
  map = new google.maps.Map(document.getElementById('map'), {
    zoom: 6,
    draggable: true,
    scrollwheel: false,
    mapTypeControl: false,
    streetViewControl: false,
    navigationControl: true,
    scaleControl: false,
    zoomControl: true,
    center: new google.maps.LatLng("46.6326782", "-73.4600171"),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    styles: [{
      featureType: 'all',
      stylers: [{
        hue: '#002643'
      }, {
        saturation: -60
      }]
    }, {
      featureType: 'road.local',
      //elementType: 'geometry',
      stylers: [{
        hue: '#ee343f'
      }, {
        saturation: 100
      }]
    }, {
      featureType: 'poi.business',
      elementType: 'labels',
      stylers: [{
        visibility: 'off'
      }]
    }]
  });
}

var nbElementsPerPage = 20;
var nbMaxPages = 1;

function showAllDistances() {
  document.getElementById('map').style.width="70%";
  document.getElementById('map-content-distance').style.width="30%";
  if (document.getElementById('detaillant')) {
  var select = document.getElementById('detaillant');
  //select.innerHTML = '<option value="0">Choisir...</option>';
  select.innerHTML = '';
  //select.remove(1);select.remove(2);select.remove(3);select.remove(4);select.remove(5);
  /*var selectoptions = select.options.length;
  if (selectoptions > 1) {
    for(var i = 1 ; i <= 6; i++) {
     select.remove(i);
      //alert(i+'/'+selectoptions);
    }
  }*/
  }
/*
  select = document.getElementById('selectElementId');

for (var i = min; i<=max; i++){
var opt = document.createElement('option');
opt.value = i;
opt.innerHTML = i;
select.appendChild(opt);
}

var x = document.getElementById("mySelect");
var option = document.createElement("option");
option.text = "Kiwi";
x.add(option);

var x = document.getElementById("mySelect");
x.remove(2);

*/
  var nbElements = 0;
  var nbPages = 0;
  var Html = "";

  if (lang == 'fr') {
    var linklabel = 'Contacter le dÃ©taillant';
  } else {
    var linklabel = 'Contact the dealer';
  }
  console.log(distances[0][0], distances[1][0])
  /*
   for (var i = 0; i < distances.length; i++) {
   limitÃ© le nombre de rÃ©sultat
   */
  for (var i = 0; i < 5; i++) {
    var currentElement = distances[i][0];
    var elementHtml = "";

    if (nbElements == 0) {
      nbPages++;

      if (nbPages > nbMaxPages) {
        nbPages--;
        break;
      }

      var pageHidden = nbPages > 1 ? "style='display:none;'" : "";
      elementHtml += "<div class='pages' id='page-" + nbPages + "' " + pageHidden + ">";
    }

    elementHtml += "<a target='_top' href='tel:" + locationsInfos[currentElement][2] + "'>";
    elementHtml += "<div class='distanceElement saira'>";
    //elementHtml += "<div class='spacer'>"+distances[i][0]+"</div>";
    var nb_km = parseFloat(distances[i][1] / 1000).toFixed(1);
    elementHtml += "<div class='infos saira'>&nbsp;<br><strong><span style='font-size:1.4em'>" + locationsInfos[currentElement][0] + "</span><br>" + locationsInfos[currentElement][1] + "<br>" + formatPhoneNumber(locationsInfos[currentElement][2]) + "</strong></div>";
    elementHtml += "<div class='km' style='margin-bottom:3px'>" + nb_km + " km </div>";
    //elementHtml += "<div class='btn'>" + linklabel + "</div>";
    //elementHtml += "<div class='spacer'></div>";
    elementHtml += "</div>";
    elementHtml += "</a>";
    nbElements++;

    if (nbElements == nbElementsPerPage || i == distances.length - 1) {
      elementHtml += "</div>";
      nbElements = 0;
    }

    Html += elementHtml;
  }

  if (nbPages > 1) {
    var pagination = "<div class='pagination-wrapper'>";

    for (var i = 0; i < nbPages; i++) {
      pagination += "<div class='paginationItem' onclick='changePage(" + (i + 1) + ")'>" + (i + 1) + "</div>";
    }

    pagination += "</div>";
    Html += pagination;
  }

  //$("#distance-wrapper").html(Html);
  document.getElementById('distance-wrapper').innerHTML = Html;
  //resizePage();
}

function initMap() {
  var endpoint = document.getElementById('dealers-json').innerHTML;
  //alert(endpoint);
  //alert('loadmap');
  var xhr = new XMLHttpRequest();
  //xhr.open("GET", "https://45c866-e0.myshopify.com/fr/pages/dealers-json", false);
  xhr.open("GET", endpoint, false);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function() {
    if (xhr.readyState === 4 && xhr.status === 200) {
      var data = JSON.parse(xhr.responseText);
      console.log(data);
      locations = data.detaillants;
      locationsInfos = data.infos;
      //alert(locationsInfos.length);
      console.log(locationsInfos);
    } else {
      alert('error');
    }
  };
  xhr.send();

  if(locations == "null"){
    setDefaultMap();
    return;
  }

  possibleErrors = [["45.536465,-73.6146708", ['montreal', 'montrÃ©al']], ["quebec city", ["quebec", "quÃ©bec"]], ["St-JÃ©rÃ´me", ["saint-jerome", "st-jerome", "saint-JÃ©rÃ´me"]], ["Trois-RiviÃ¨res", ["trois-rivieres", "trois rivieres", "trois riviere", "trois-riviere"]], //["laval, quebec",["laval"]],
  //["chambly, quebec",["chambly"]],
  ["Pierrefonds quebec", ["pierrefonds"]], ["verdun, quebec", ["verdun"]], ["hammond, ontario", ["hammond"]], ["saint-damien-de-buckland", ["st-damien", "saint-damien"]], //["deauville, quebec",["deauville"]],
  //["kirkland montreal",["kirkland"]],
  ["saint-hubert,quebec", ["saint-hubert", "st-hubert"]], ["orleans, ontario", ["orleans", "orlean", "orlÃ©an", "orlÃ©ans"]], //["amos, quebec",["amos"]],
  ['sorel, quebec', ['sorel', 'sorel-tracy', 'tracy']], ['saint-jean-sur-richelieu ,quebec', ['st-jean']] //['pierrefonds, quebec',['pierrefonds']]
  ];

  montrealCoords = [{
    lat: 45.41749,
    lng: -73.68711
  }, {
    lat: 45.40086,
    lng: -73.9858
  }, {
    lat: 45.4511,
    lng: -73.98923
  }, {
    lat: 45.52219,
    lng: -73.9142
  }, {
    lat: 45.51819,
    lng: -73.84192
  }, {
    lat: 45.51307,
    lng: -73.75848
  }, {
    lat: 45.52929,
    lng: -73.73852
  }, {
    lat: 45.55644,
    lng: -73.67801
  }, {
    lat: 45.59371,
    lng: -73.65198
  }, {
    lat: 45.6384,
    lng: -73.62115
  }, {
    lat: 45.6617,
    lng: -73.57126
  }, {
    lat: 45.69746,
    lng: -73.52514
  }, {
    lat: 45.7129,
    lng: -73.44644
  }, {
    lat: 45.65502,
    lng: -73.45307
  }, {
    lat: 45.52785,
    lng: -73.5366
  }, {
    lat: 45.45405,
    lng: -73.5169
  }, {
    lat: 45.4046,
    lng: -73.61758
  }];
  lavalCoords = [{
    lat: 45.70402,
    lng: -73.51407
  }, {
    lat: 45.68172,
    lng: -73.70067
  }, {
    lat: 45.67938,
    lng: -73.73238
  }, {
    lat: 45.60599,
    lng: -73.81354
  }, {
    lat: 45.55511,
    lng: -73.88267
  }, {
    lat: 45.52151,
    lng: -73.89962
  }, {
    lat: 45.51164,
    lng: -73.76023
  }, {
    lat: 45.54027,
    lng: -73.71286
  }, {
    lat: 45.55758,
    lng: -73.67595
  }, {
    lat: 45.62629,
    lng: -73.63003
  }];
  quebecCoords = [{
    lat: 46.9151,
    lng: -71.36659
  }, {
    lat: 46.77938,
    lng: -71.46444
  }, {
    lat: 46.65533,
    lng: -71.3096
  }, {
    lat: 46.76015,
    lng: -70.97005
  }, {
    lat: 46.95109,
    lng: -71.0521
  }];
  sorelCoords = [{
    lat: 45.81971,
    lng: -73.30053
  }, {
    lat: 45.76585,
    lng: -73.37485
  }, {
    lat: 45.70043,
    lng: -73.44644
  }, {
    lat: 45.74513,
    lng: -73.09367
  }, {
    lat: 45.89936,
    lng: -72.91313
  }, {
    lat: 45.96923,
    lng: -72.82047
  }, {
    lat: 46.06189,
    lng: -72.78275
  }, {
    lat: 46.15439,
    lng: -72.78897
  }, {
    lat: 46.14336,
    lng: -72.913
  }, {
    lat: 46.04756,
    lng: -73.15513
  }, {
    lat: 45.99112,
    lng: -73.17659
  }];
  sherbrookeCoords = [{
    lat: 45.48084,
    lng: -71.37998
  }, {
    lat: 45.52968,
    lng: -71.92672
  }, {
    lat: 45.38592,
    lng: -72.23176
  }, {
    lat: 45.18422,
    lng: -72.34952
  }, {
    lat: 45.20672,
    lng: -71.87402
  }];
  specificExceptions = [//[ville,position,zoom,zone,couleur,forcePosition]
  ["Laval", {
    lat: 45.6066486,
    lng: -73.7124091
  }, 11, lavalCoords, '#ffa500', false], ["Montreal", {
    lat: 45.536465,
    lng: -73.6146708
  }, 11, montrealCoords, '#008080', false], ["Quebec", {
    lat: 46.799122,
    lng: -71.222797
  }, 11, quebecCoords, '#FF0000', false], ["Sherbrooke", {
    lat: 45.356464,
    lng: -72.007237
  }, 11, sherbrookeCoords, '#00FF00', false] //["Sorel",{lat:45.685342,lng : -73.410415},10,sorelCoords,'#FF69B4',true]
  ];


  var start = 0;
  var end = locations.length;
  var clatt = locations[0][1];
  var clong = locations[0][2];
  var czoom = 10;


  var bounds = new google.maps.LatLngBounds();
  var infowindow = new google.maps.InfoWindow();
  var isDraggable = window.innerWidth > 480 ? true : false; // If document (your website) is wider than 480px, isDraggable = true, else isDraggable = false

  var zooom = Math.round(window.innerWidth / 240);
  if (zooom < 3) zooom = 3;
  if (zooom > 5) zooom = 5;

map = new google.maps.Map(document.getElementById('map'), {
  zoom: czoom,
  draggable: true, // voir var isDraggable
  scrollwheel: false,
  mapTypeControl: false,
  streetViewControl: false,
  navigationControl: true,
  scaleControl: false,
  zoomControl: true,
  center: new google.maps.LatLng(clatt, clong),
  mapTypeId: google.maps.MapTypeId.ROADMAP,
  styles: [{
    featureType: 'all',
    stylers: [{
      hue: '#000000'
    }, {
      saturation: -60
    }]
  }, {
    featureType: 'road.local',
    //elementType: 'geometry',
    stylers: [{
      hue: '#000000'
    }, {
      saturation: 0
    }]
  }, {
    featureType: 'water',
    //elementType: 'geometry',
    stylers: [{
      color: '#333333'
    }]
  }, {
    featureType: 'poi.business',
    elementType: 'labels',
    stylers: [{
      visibility: 'off'
    }]
  }]
});

for (var i = 0; i < specificExceptions.length; i++) {
  specificExceptions[i][6] = new google.maps.Polygon({
    paths: specificExceptions[i][3],
    strokeColor: specificExceptions[i][4],
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: specificExceptions[i][4],
    fillOpacity: 0.35
  });

  if (debug) {
    specificExceptions[i][5].setMap(map);
  }
}

var marker, i;
var icon = {
  url: "https://cdn.shopify.com/s/files/1/0608/6891/9350/files/pin.png?v=1722281099",
  // url
  scaledSize: new google.maps.Size(30, 40)
};

for (i = 0 + start; i < 0 + end; i++) {
  marker = new google.maps.Marker({
    position: new google.maps.LatLng(locations[i][1], locations[i][2]),
    map: map,
    icon: icon
  });
  markers.push(marker);
  var loc = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
  bounds.extend(loc);
  google.maps.event.addListener(marker, 'click', function (marker, i) {
    return function () {
      infowindow.setContent("<strong>" + locationsInfos[i][0] + "</strong><br>" + locationsInfos[i][1] + "<br><br><strong>" + formatPhoneNumber(locationsInfos[i][2]) + "</strong>");
      infowindow.open(map, marker);
    };
  }(marker, i));
}


var lastSearch = document.querySelector("#lastSearch");

if (lastSearch !== null) {
  if (lastSearch.value.trim().length > 0) {
    getMapPoint(lastSearch.value);
  } else {
    viewAllMarkers();
  }
}
viewAllMarkers();
//resizePage();

}

function formatPhoneNumber(number) {
  // Assurez-vous que le numéro est une chaîne de caractères
  const phoneNumber = number.toString();
  
  // Utilisez une expression régulière pour formater le numéro
  const formattedNumber = phoneNumber.replace(/^(\d{3})(\d{3})(\d{4})$/, '$1-$2-$3');
  
  return formattedNumber;
}

function resizePage() {
  /*
  window.parent.postMessage({
    sentinel: 'amp',
    type: 'embed-size',
    height: document.body.scrollHeight
  }, '*');
  */
}

document.addEventListener("DOMContentLoaded", function() {
    fetch('https://api.pubinteractive.ca/bpwr/shopify/dealers.php')
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();  // Assuming your PHP returns JSON data
        })
        .then(data => {
            if (data.status === 'success') {
                console.log('Success PI API CALL:', data.message);
                // Ici vous pouvez manipuler le DOM ou effectuer d'autres actions
            } else {
                console.error('Error PI API CALL:', data.message);
            }
        })
        .catch(error => {
            console.error('There was a problem with the fetch operation:', error);
        });
});